/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationByOptimizationTypeWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostOptimizationByOptimizationTypeWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostOptimizationByOptimizationTypeWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationByOptimizationTypeWidgetConfiguration>): CostOptimizationByOptimizationTypeWidgetConfiguration {
        let obj = Object.assign(new CostOptimizationByOptimizationTypeWidgetConfiguration(), model);
        CostOptimizationByOptimizationTypeWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationByOptimizationTypeWidgetConfiguration>): CostOptimizationByOptimizationTypeWidgetConfiguration {
        if (!model) return null;
        return CostOptimizationByOptimizationTypeWidgetConfiguration.newInstance(<CostOptimizationByOptimizationTypeWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationByOptimizationTypeWidgetConfiguration) {
        if (!obj) return;

        models.CostOptimizationByOptimizationTypeWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationByOptimizationTypeWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostOptimizationByOptimizationTypeWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of Optimization
     */
    optimizationType: models.OptimizationType;

}
